import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { Loader, Center, Stack, Text } from '@mantine/core';

/**
 * NonProfitUserRoute - Route guard for non-profit users only
 *
 * Requires authentication AND NonProfitUser role.
 * Redirects to / if not authenticated, /access-denied if wrong role.
 *
 * Sprint 062 Session 7
 */
export const NonProfitUserRoute: React.FC = (): React.ReactElement => {
  const { isAuthenticated, isNonProfitUser, isLoading } = useAuth();

  console.log('[NonProfitUserRoute] Auth state:', { isAuthenticated, isNonProfitUser, isLoading });

  // Show loading state while checking authentication
  if (isLoading) {
    console.log('[NonProfitUserRoute] ⏳ Loading, showing spinner...');
    return (
      <Center h="100vh">
        <Stack align="center" gap="md">
          <Loader size="lg" />
          <Text size="sm" c="dimmed">
            Loading...
          </Text>
        </Stack>
      </Center>
    );
  }

  // Redirect to home if not authenticated
  if (!isAuthenticated) {
    console.log('[NonProfitUserRoute] ❌ Not authenticated, redirecting to home');
    return <Navigate to="/" replace />;
  }

  // Redirect to access denied if not non-profit user
  if (!isNonProfitUser) {
    console.log('[NonProfitUserRoute] ❌ Not a non-profit user, redirecting to access-denied');
    return <Navigate to="/access-denied" replace />;
  }

  console.log('[NonProfitUserRoute] ✅ Authenticated as non-profit user, rendering routes');
  return <Outlet />;
};
